module.exports = __webpack_public_path__ + "img/AE5001-163.37af7a29.jpg";